// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3AVCZ","errors":"Errors_errors__sp_-2"};